//import { attachments } from 'data/project-management/todoListData';
import { UilStopwatch } from '@iconscout/react-unicons';
import Badge, { BadgeBg } from 'components/base/Badge';
import NPSpinner from 'components/base/NPSpinner';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import Button from 'components/base/Button';
//import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { Col, Dropdown, Row, Toast } from 'react-bootstrap';
import projectService from 'services/project';
import { Project } from 'data/projects';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from 'contexts/UserContext';
import { useState, useEffect, useContext } from 'react';
//import interceptor from 'services/interceptor';
import pitchDeckStatusService from 'services/pitchdeckstatus';
import { PitchDeck } from 'data/pitchdecks';
import pitchDeckService from 'services/pitchdeck';
//import FileListItem from '../../../components/modules/project-management/pitchDeck-list/FileListItem';
import interceptor from 'services/interceptor';

const ProjectDetails = () => {
  //const { setContentClass } = useMainLayoutContext();
  const [projectData, setProjectData] = useState<Project | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { projectId } = useParams();
  const navigate = useNavigate();
  const context = useContext(UserContext);
  const [showDeletedToast, setShowDeletedToast] = useState(false);
  const [pitchDecks, setPitchDecks] = useState([]);
  const [toastText, setToastText] = useState('');

  useEffect(() => {
    interceptor.apiWithAuth
      .get(`/pitchdeck/get-pitchdecks-by-project-id/${projectId}`)
      .then(response => {
        setPitchDecks(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (!context || !context.user) {
      navigate('/pages/authentication/split/sign-in');
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (projectId) {
      projectService
        .getProjectByID(projectId)
        .then(data => {
          setProjectData(data);
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
          if (error.response && error.response.status === 400) {
            navigate('/pages/error/400');
          }
        });
    } else {
      setIsLoading(false);
    }
  }, [projectId, navigate]);
  if (isLoading) {
    return <NPSpinner />;
  }
  // useEffect(() => {
  //   setContentClass('px-0 pt-navbar');

  //   return () => {
  //     setContentClass('');
  //   };
  // }, []);
  const handleCreateButtonClick = async () => {
    // Create a blank starter project and navigate to the create pitchdeck page
    // then we can update the project with the pitchdeck and data that belongs to it
    const generateGuid = (): string => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    };

    const draftStatus =
      await pitchDeckStatusService.getPitchDeckStatusByName('Draft');

    const pitchDeck: PitchDeck = {
      pitchDeckId: generateGuid(),
      projectId: projectId,
      generatedByAI: false,
      title: 'Empty PitchDeck',
      type: 'film',
      contentOuterHtml: '',
      publishedURN: '',
      trackingEnabled: true,
      thumbnail:
        'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_f7533443-7bcc-419d-abc4-3b17a1169a92_101_bg_img.jpg',
      isTemplate: false,
      statusId: draftStatus.statusId,
      status: draftStatus,
      createdBy: localStorage.getItem('userId') || ''
    };

    pitchDeckService.addPitchDeck(pitchDeck).then(data1 => {
      if (data1) {
        if (projectData) {
          projectData.pitchDecks = [data1];
          navigate(
            `/pages/slide-editor/${projectData.projectId}/${pitchDeck.pitchDeckId}`
          );
        }
      } else {
        console.error('Error:', 'problem with returned pitchdeck ID');
      }
    });
  };
  const handleEditProjectClick = async () => {
    const project: Project = {
      projectId: projectData?.projectId,
      title: projectData?.title || '',
      userId: context.user?.userId
    };

    alert('Are you sure you want to edit this project?' + project.title);
  };
  const handleDeleteProjectClick = async () => {
    // Show confirmation dialog
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this project?'
    );

    if (!confirmDelete) {
      return; // If user cancels, do nothing
    }

    // Create a project of Project type from projectData to send to the delete function
    const project: Project = {
      projectId: projectData?.projectId,
      title: projectData?.title || '',
      userId: context.user?.userId
    };

    try {
      const data = await projectService.deleteProject(project);

      if (data) {
        setToastText('Deleted project ' + project.title + ' successfully');
        setShowDeletedToast(true);
        navigate('/dashboard/project-management');
      } else {
        console.error('Error:', 'problem deleting project ' + project.title);
      }
    } catch (error) {
      console.error(
        'Error:',
        'problem deleting project ' + project.title,
        error
      );
    }
  };

  return (
    <>
      <Toast
        show={showDeletedToast}
        onClose={() => setShowDeletedToast(false)}
        className="align-items-center bg-dark border-0 bottom-0 end-0 light mb-3 me-3 position-fixed text-white z-index-5"
        delay={3000}
        autohide
      >
        <div className="d-flex">
          <Toast.Body className="P-3">
            <span className="fw-black">
              <code className="text-500">{toastText}</code>
            </span>
          </Toast.Body>
        </div>
      </Toast>
      <Row className="g-0">
        <Col xs={12} xxl={8} className="px-0 bg-soft">
          <div className="px-4 px-lg-6 pt-6">
            <div className="mb-5">
              <div className="d-flex justify-content-between">
                <h2 className="text-black fw-bolder mb-2">
                  {projectData?.title}
                </h2>
                <RevealDropdownTrigger>
                  <RevealDropdown>
                    <Dropdown.Item
                      className="text-success"
                      onClick={() => handleCreateButtonClick()}
                    >
                      Add PitchDeck to Project
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="text-success"
                      onClick={() => handleEditProjectClick()}
                    >
                      Edit Project
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="text-danger"
                      onClick={() => handleDeleteProjectClick()}
                    >
                      Delete
                    </Dropdown.Item>
                    {/* <Dropdown.Item>Download</Dropdown.Item>
                    <Dropdown.Item>Report abuse</Dropdown.Item> */}
                  </RevealDropdown>
                </RevealDropdownTrigger>
              </div>
              <Badge
                variant="phoenix"
                bg={projectData?.status?.displayType as BadgeBg}
                iconPosition="end"
                icon={<UilStopwatch size={12} className="ms-1" />}
              >
                {projectData?.status?.label}
              </Badge>
            </div>
            <div className="mb-5">
              <h3 className="text-1100 mb-4">Brief Outline</h3>
              <p className="text-800 mb-4">{projectData?.briefOutline}</p>
            </div>
            <div>
              <h3 className="text-1100 mb-4">Tagline</h3>
              <p className="text-800 mb-4">{projectData?.tagline}</p>
              <h3 className="text-1100 mb-4">Logline</h3>
              <p className="text-800 mb-4">{projectData?.logline}</p>
              <h3 className="text-1100 mb-4">Synopsis</h3>
              <p className="text-800 mb-4">{projectData?.synopsis}</p>
            </div>
          </div>
        </Col>

        <Col xs={12} xl={7}>
          <div className="px-5 pb-5 d-flex justify-content-center">
            {(!pitchDecks || pitchDecks?.length == 0) && (
              <Button
                variant="link"
                className="text-decoration-none p-2 btn btn-soft-info"
                onClick={() => handleCreateButtonClick()}
              >
                Create Deck
              </Button>
            )}

            {projectData && pitchDecks?.length > 0 && (
              <Button
                variant="link"
                className="text-decoration-none p-2 btn btn-soft-info w-100"
                onClick={() =>
                  navigate(`/pages/slide-editor/${projectData?.projectId}
                  /${(pitchDecks[0] as PitchDeck).pitchDeckId}`)
                }
              >
                Edit Deck
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ProjectDetails;
